import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import { Collapse } from 'reactstrap';
import Skill1 from './EditSkill1';
import Skill2 from './EditSkill2';
import classnames from 'classnames';
import {
    BrowserRouter as Router, Switch, Route, useHistory
  } from "react-router-dom";
import { SelectDD , ExternalDD } from '../../../../common/dropdowns';

const Link = ({ title, isActive, handleOnClick, idx }) => {
    const cx = classnames({
      'nav-link': true,
      active: isActive,
    });
    return (
      <li className="nav-item" onClick={() => handleOnClick(idx)}>
        <a className={cx} role="tab">
          {title}
        </a>
        <div className="slide" />
      </li>
    );
  };
  
const links = ['Web Design & Software Development', 'Data Science & Analytics'];

const skillData = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'example1', label: 'Example1' },
    { value: 'example2', label: 'Example2' },
  ]

const EditMySkillModal = ({ modal, toggle }) => {

    var history = useHistory();
    const onNavigate = (o) => {
      history.push(o)
    }

    const onDDClick = (o) => {
      console.log("DD CLICK", o)
      history.push(o.value)
    }

    const [collapse, setCollapse] = useState(false);
    const togglecollapse = () => setCollapse(!collapse);
    const [selected, setSelected] = useState(skillData[0]);
    const [view, setView] = useState(0);
    const renderView = (view) => {
        switch(view) {
            case 0: 
                return <div><Skill1/></div>    
            case 1: 
                return <div><Skill2/></div> 
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-900">        
        <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
            <div className="modal-header">Edit Expertise & Skills</div>
            <div className="v-align f-right" style={{marginLeft:'auto'}}>
                <i className="fa fa-cog modal-close mg-r-15" ></i> 
                <i className="far fa-question-circle modal-close mg-r-15" ></i>
                <i className="fas fa-times modal-close" onClick={toggle}></i>
            </div>
        </div>   
        <hr className="mg-r-0"></hr>
        <div className="modal-block">
            <div className="modal-subheader">Add Expertise Area</div>            
            <div className="row">
                <div className="col-md-6">
                <SelectDD data={skillData} onChange={(o) => setSelected(o)} selected={selected} isClearable={false} />
                </div>
                <div className="col-md-6">
                    <button className="btn btn-primary">
                        <i className="fas fa-plus mg-r-5"></i>Add Expertise
                        <span className="button-info">4</span>
                    </button>
                </div>
            </div>
        </div>
        <hr className="mg-0"></hr>
            <div className="row">
                <div className="wd-pct-23 b-r-border pd-l-25 pd-t-15 pd-r-5">
                    <ul className="nav nav-left-tabs md-tabs tabs-left">
                        <div className="col-md-12">
                            <div className="row">
                                {links.map((l, i) => (
                                    <Link
                                        key={i}
                                        idx={i}
                                        title={l}
                                        isActive={i === view}
                                        handleOnClick={setView}
                                     />
                                ))}
                            </div> 
                        </div> 
                    </ul>
                </div>
                <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
                    {renderView(view)}
                </div>
            </div>       
        
        <hr className="mg-0 "></hr>
        <div className="pd-20 box-shadow-top">
            <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>             
            <button className="btn btn-primary-lite f-right mg-r-15">Save</button>
            <button className="btn btn-success-lite mg-r-15 f-right">Reset</button>            
        </div>
    </Modal>
)}
export default EditMySkillModal;